var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('toggle-panel', {
    attrs: {
      "title": "Qiwi",
      "disabled": _vm.isDisabledPaymentOption
    },
    on: {
      "click": _vm.handleClickOnPanel
    },
    model: {
      value: _vm.isQiwiMethodActive,
      callback: function callback($$v) {
        _vm.isQiwiMethodActive = $$v;
      },
      expression: "isQiwiMethodActive"
    }
  }, [_c('qiwi-icon', {
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  })], 1), _c('cs-dialog', {
    on: {
      "close": _vm.cancelModal
    },
    model: {
      value: _vm.isModalActive,
      callback: function callback($$v) {
        _vm.isModalActive = $$v;
      },
      expression: "isModalActive"
    }
  }, [_c('dialog-default-layout', [_c('div', {
    staticClass: "modal-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('payment.method.settings')))]), _c('a', {
    staticClass: "modal-help-icon",
    attrs: {
      "href": "https://help.capusta.space/payment_page/qiwi",
      "target": "_blank"
    }
  })]), _c('template', {
    slot: "content"
  }, [_c('div', {
    staticClass: "input-container"
  }, [_c('capusta-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '+###############',
      expression: "'+###############'"
    }],
    attrs: {
      "validation": _vm.validateMerchantPhoneNumber,
      "label": _vm.$t('qiwi.wallet.number'),
      "placeholder": _vm.$t('enter.number'),
      "data-private": ""
    },
    model: {
      value: _vm.merchantPhoneNumber,
      callback: function callback($$v) {
        _vm.merchantPhoneNumber = $$v;
      },
      expression: "merchantPhoneNumber"
    }
  })], 1), _c('div', {
    staticClass: "input-container"
  }, [_c('capusta-input', {
    attrs: {
      "label": _vm.$t('qiwi.token'),
      "placeholder": _vm.$t('insert.token'),
      "data-private": ""
    },
    model: {
      value: _vm.merchantQiwiToken,
      callback: function callback($$v) {
        _vm.merchantQiwiToken = $$v;
      },
      expression: "merchantQiwiToken"
    }
  }, [!_vm.merchantQiwiToken ? _c('c-link', {
    attrs: {
      "slot": "link",
      "href": "https://qiwi.com/api",
      "target": "_blank"
    },
    slot: "link"
  }, [_vm._v(" " + _vm._s(_vm.$t('common.receive')) + " ")]) : _vm._e()], 1)], 1)]), _c('div', {
    staticClass: "buttons-container",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('cs-button', {
    attrs: {
      "width": _vm.buttonWidth,
      "disabled": !_vm.isValidForm
    },
    on: {
      "click": _vm.qiwiMethod
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.apply')) + " ")]), _c('cs-button', {
    attrs: {
      "width": _vm.buttonWidth,
      "type": "transparent"
    },
    on: {
      "click": _vm.cancelModal
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.cancel')) + " ")])], 1)], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }